"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTranslate = exports.getTabId = exports.getSectionTl = exports.getPinTl = exports.getCoords = exports.calculateSectionHeights = exports.CONTAINER_ID = void 0;
var _lodash = require("lodash");
var _all = require("gsap/all");
_all.gsap.registerPlugin(_all.ScrollTrigger);
_all.gsap.registerPlugin(_all.ScrollToPlugin);
const CONTAINER_ID = 'bricks-story';
exports.CONTAINER_ID = CONTAINER_ID;
const getCoords = elem => {
  var box = elem.getBoundingClientRect();
  var body = document.body;
  var docEl = document.documentElement;
  var scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
  var scrollLeft = window.pageXOffset || docEl.scrollLeft || body.scrollLeft;
  var clientTop = docEl.clientTop || body.clientTop || 0;
  var clientLeft = docEl.clientLeft || body.clientLeft || 0;
  var top = box.top + scrollTop - clientTop;
  var left = box.left + scrollLeft - clientLeft;
  const coords = {
    top: Math.round(top),
    left: Math.round(left)
  };
  return coords;
};
exports.getCoords = getCoords;
const getTabId = index => {
  return `tab-item--${index}`;
};
exports.getTabId = getTabId;
const getPinTl = (pin, pinHeight) => {
  const tl = _all.gsap.to(pin, {
    scrollTrigger: {
      trigger: pin,
      scrub: true,
      start: 'top top',
      end: `+=${pinHeight}px`,
      pin: true,
      pinSpacing: false,
      scrub: true
    }
  });
  return tl;
};
exports.getPinTl = getPinTl;
const getSectionTl = (section, sectionHeight, onToggle) => {
  const tl = _all.gsap.to(section, {
    scrollTrigger: {
      trigger: section,
      start: 'top top+=10px',
      end: `+=${sectionHeight - 10}px`,
      onToggle: onToggle
    }
  });
  return tl;
};
exports.getSectionTl = getSectionTl;
const calculateSectionHeights = sections => {
  let sectionHeights = [];
  (0, _lodash.forEach)(sections, (section, index) => {
    const s = document.querySelector(`#${section.id}`);
    if (index > 0) {
      const prevS = document.querySelector(`#${sections[index - 1].id}`);
      if (s && prevS) {
        const sectionHeight = getCoords(s).top - getCoords(prevS).top;
        sectionHeights.push(sectionHeight);
      }
    }
    if (index === sections.length - 1) {
      if (s) {
        const lastSectionHeight = document.querySelector(`#${CONTAINER_ID}`).offsetHeight - getCoords(s).top;
        sectionHeights.push(lastSectionHeight);
      }
    }
  });
  return sectionHeights;
};
exports.calculateSectionHeights = calculateSectionHeights;
const getTranslate = myElement => {
  var style = window.getComputedStyle(myElement);
  var matrix = new DOMMatrix(style.transform);
  return {
    x: matrix.m41,
    y: matrix.m42
  };
};
exports.getTranslate = getTranslate;
//# sourceMappingURL=utilities.js.map